import { Box, Typography, IconButton, Link } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

const MapCard = ({ pais, compania, nombre, mail, telefono, onClose }) => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: { xs: "90%", sm: "45%", md: "30rem" },
          maxWidth: "100%",
          minHeight: "10rem",
          borderRadius: "2rem",
          overflow: "hidden",
          border: "1px solid #1B2466",
          background: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          py: { xs: "1rem", sm: "2rem" },
          px: { xs: "1.5rem", sm: "2.5rem" },
        }}
      >
        {/* 🔹 Botón de cierre arriba a la derecha */}
        {onClose && (
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: "0.5rem",
              right: "0.5rem",
              color: "#1B2466",
              "&:hover": { background: "transparent", color: "#0e1440" },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}

        <Typography
          variant="h6"
          sx={{
            color: "#1B2466",
            fontFamily: "Montserrat",
            fontSize: { xs: "18px", sm: "21.3px" },
            fontWeight: 700,
            mb: { xs: "0.3rem", sm: "0.5rem" },
          }}
        >
          {pais.toUpperCase()}
        </Typography>

        {compania && (
          <Typography
            sx={{
              color: "#1B2466",
              fontFamily: "Montserrat",
              fontSize: { xs: "16px", sm: "20px" },
              lineHeight: { xs: "20px", sm: "25px" },
              mb: "0.3rem",
            }}
          >
            {compania} - {nombre}
          </Typography>
        )}

        {mail && (
          <Link
            href={`mailto:${mail}`}
            sx={{
              color: "#1B2466",
              fontFamily: "Montserrat",
              fontSize: { xs: "16px", sm: "20px" },
              mb: "0.3rem",
            }}
          >
            {mail}
          </Link>
        )}

        {telefono && (
          <Link
            href={`tel:${telefono}`}
            sx={{
              color: "#1B2466",
              fontFamily: "Montserrat",
              fontSize: { xs: "16px", sm: "20px" },
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            {telefono}
          </Link>
        )}
      </Box>
    </Box>
  );
};

export default MapCard;
